co<template>
  <div class="mainContaner full_w">
    <loading v-show="showLoading"></loading>
    <div v-if="!showLoading">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <!--首页搜索-->
        <div class="nav_bar">
          <button class="clear_style fl nav_bar_left_item" style="width: 2rem;height: 2rem" ><img class="nav_item_btn" src="@/images/back.png" @click="$router.back(-1)" ></button>
          <p class="clear_style fl nav_bar_search tc">选择赠送</p>
        </div>
        <div style="padding-top: 2.5rem;">
          <div class="clear_both" style="padding-bottom: 3rem">
            <div class="pl_info1 fl" v-for="(productItem,index) in productList" :key="index">
              <van-image class="pl_info1_img" fit="cover" :src="productItem.imageUrl"/>
              <p class="pl_info1_title">{{productItem.productName}}</p>
              <span @click="changeGiftItem(productItem.productId)" class="pl_info1_addCart fr" >更换</span>
            </div>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>

  import Vue from 'vue';
  import { storeName,prodCatalogId } from '@/router/Constant'
  import { getCartGiftList,changeGiftItem,login } from '@/router/api';
  import { setStore,getStore,getCookie,setCookie } from '@/utils/mUtil';
  import { Image,Button } from 'vant';
  import {Overlay,PullRefresh,Toast } from 'vant';
  import footerView from '../common/footer';
  import loading from '@/components/page/common/loading.vue';
  import refresh from '@/components/page/common/refresh.vue';
  export default {
    name: "collectBills",
    data() {
      return {
        productStoreId:storeName,
        prodCatalogId:prodCatalogId,
        shoppingListItemSeqId:this.$route.query.shoppingListItemSeqId,
        productList:[],
        isLoading:false,
        showLoading:true,
      }
    },
    components: {
      [Image.name]: Image,
      [Button.name]: Button,
      [Overlay.name]: Overlay,
      [PullRefresh.name]: PullRefresh,
      [Toast.name]: Toast,
      footerView,
      loading,
      refresh
    },
    methods:{
      async initData() {
        this.getCartGiftList();
      },
      getCartGiftList() {
        getCartGiftList({externalLoginKey:getStore('externalLoginKey'),productStoreId:this.productStoreId,prodCatalogId:prodCatalogId,viewIndex:0,viewSize:20,shoppingListItemSeqId:this.shoppingListItemSeqId})
          .then(res => {
            console.log("getCartGiftList")
            console.log(res)
            this.productList = res.productList
            setTimeout(() => {
              this.showLoading = false;
            }, 1000);
            if (res.productList.length == 0) {
              Toast('没有查到赠品')
            }
          })
          .catch(err => {
            console.log(err);
            this.showLoading = false
          });
      },
      changeGiftItem(productId) {
        changeGiftItem({externalLoginKey:getStore('externalLoginKey'),productStoreId:this.productStoreId,prodCatalogId:prodCatalogId,shoppingListItemSeqId:this.shoppingListItemSeqId,productId:productId})
          .then(res => {
            console.log("changeGiftItem");
            console.log(res);
            if (res._ERROR_MESSAGE_) {
              Toast(res._ERROR_MESSAGE_);
            } else {
              Toast(res._EVENT_MESSAGE_);
            }
            this.$router.back(-1);
          })
          .catch(err => {
            console.log(err);
          });
      },
      resetScorllView() {
        this.$router.afterEach((to,from, next) => {
          window.scrollTo(0,0)
        })
      },
      //下拉刷新
      onRefresh() {
        setStore('onRefresh',"onRefresh")
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      },
    },
    mounted() {
      this.initData();
      this.resetScorllView();
    }

  }
</script>

<style lang="scss" scoped>

  .mainContaner {
    position: absolute;top: 0;
  }

  .nav_bar {
    background-color: white;padding-top: 0.5rem;position: fixed;top: 0;left: 0;width: 100%;border-bottom: 1px solid #eaeaea;z-index: 101;
  }

  .nav_bar_left_item {
    padding-top: 0.3rem;
  }

  .nav_item_btn {
    width: 1.25rem;height: 1.25rem;
  }

  .nav_bar_search {
    width: 16.3rem;margin: 0 0.4rem;background-color: white;height: 2rem;line-height: 2rem;padding: 0 0.8rem
  }

  .pl_info1 {
    width: 11.68rem;height: 15.625rem;padding-bottom: 0.5rem;border-bottom: 1px solid #eaeaea;
  }

  .pl_info1_img {
    width: 11.68rem;
    height: 11.68rem;
  }

  .pl_info1:nth-child(odd) {
    border-right: 1px solid #eaeaea;
  }

  .pl_info1_title {
    padding: 0 0.1rem;margin:0 0.5rem 0;font-size: 0.75rem;color: #333333;margin-bottom: 0.5rem;
  }

  .pl_info1_price {
    margin-left: 0.5rem;font-size: 0.875rem;color: #EB84AB;font-weight: bold;
  }

  .pl_info1_addCart {
    margin-right: 0.5rem;font-size: 0.75rem;color: #999999;
    border: 1px solid #EB84AB;color: #EB84AB;padding: 0.1rem 0.5rem;border-radius: 0.7rem;position: relative;margin-top: -0.3rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/page/cart/collectBills.vue